import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-186285fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "confirmUpdateModal",
  tabindex: "-1",
  "aria-labelledby": "confirmUpdateModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "exampleModalLabel"
}
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "row mx-0 bg-white mx-auto" }
const _hoisted_8 = { class: "fw-bold mb-4 fs-6 p-2 text-lg-start text-center" }
const _hoisted_9 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_10 = { class: "w-max-content col-lg-3" }
const _hoisted_11 = { class: "col-lg-4" }
const _hoisted_12 = { class: "col-lg-4" }
const _hoisted_13 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_14 = { class: "w-max-content col-lg-3" }
const _hoisted_15 = { class: "col-lg-4" }
const _hoisted_16 = { class: "col-lg-4" }
const _hoisted_17 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_18 = { class: "w-max-content col-lg-3" }
const _hoisted_19 = { class: "col-lg-8" }
const _hoisted_20 = {
  key: 0,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_21 = { class: "w-max-content col-lg-3" }
const _hoisted_22 = { class: "col-lg-9" }
const _hoisted_23 = {
  key: 1,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_24 = { class: "w-max-content col-lg-3" }
const _hoisted_25 = { class: "col-lg-9" }
const _hoisted_26 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_27 = { class: "w-max-content col-lg-3" }
const _hoisted_28 = { class: "col-lg-4" }
const _hoisted_29 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_30 = { class: "w-max-content col-lg-3" }
const _hoisted_31 = { class: "col-lg-9" }
const _hoisted_32 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_33 = { class: "w-max-content col-lg-3" }
const _hoisted_34 = {
  key: 0,
  class: "col-lg-4"
}
const _hoisted_35 = { class: "fw-bold mb-4 fs-6 p-2 text-lg-start text-center" }
const _hoisted_36 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_37 = { class: "w-max-content col-lg-3" }
const _hoisted_38 = { class: "col-lg-8" }
const _hoisted_39 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_40 = { class: "w-max-content col-lg-3" }
const _hoisted_41 = { class: "col-lg-4" }
const _hoisted_42 = { class: "col-lg-4" }
const _hoisted_43 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-5" }
const _hoisted_44 = { class: "w-max-content col-lg-3" }
const _hoisted_45 = { class: "col-lg-4" }
const _hoisted_46 = { class: "fw-bold mb-4 fs-6 p-2 text-lg-start text-center" }
const _hoisted_47 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_48 = { class: "w-max-content col-lg-3" }
const _hoisted_49 = { class: "col-lg-8" }
const _hoisted_50 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_51 = { class: "w-max-content col-lg-3" }
const _hoisted_52 = {
  key: 0,
  class: "col-lg-8"
}
const _hoisted_53 = {
  key: 1,
  class: "col-lg-8"
}
const _hoisted_54 = { class: "row mx-0 px-0 d-flex justify-content-center flex-lg-row flex-column-reverse" }
const _hoisted_55 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center" }
const _hoisted_56 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center mb-4 mb-lg-0" }

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import { computed, ref, watchEffect, onMounted, PropType } from 'vue'
import { useStore } from 'vuex'
import { AUTH_STORE, COMMUNITY_STORE, USER_STORE } from '@/store/constants'
import alumnusServices from '@/services/alumnus-profile.services'
import UpdateAlumniComplete from '../edit-complete/index.vue'

import { Modal } from 'bootstrap'
import dayjs from 'dayjs'

import { PATH, PREFECTURES } from '@/constants/index'
import { AuthenMethodTypes } from '@/store/modules/register-alumnus'
import { getCookie, removeCookie } from '@/utils'
import { useRoute } from 'vue-router'

// 2022/09/12 TienNV Fix double click button confirm

export default /*#__PURE__*/_defineComponent({
  props: {
  jobNameParent: {
    type: String,
  },
  jobNameChild: {
    type: String,
  },
  errorUpdate: {
    type: Boolean,
  },
  handleError: {
    type: Function as PropType<() => void | undefined> | any,
  },
},
  setup(__props, { expose }) {

const props = __props

const modalConfirm = ref()
const modalCompleted = ref()

const store = useStore()
const route = useRoute()
const data = computed(() => store.getters[USER_STORE.GETTERS.ALUMNI_PROFILE])
const path = route.path.split('/')[1]



const jobName = computed(() => {
  const { jobNameParent, jobNameChild } = props
  return {
    parent: jobNameParent,
    child: jobNameChild,
  }
})

const submittingButton = ref<boolean>(false)
const errorForm = ref<boolean>(false)

watchEffect(() => {
  errorForm.value = props.errorUpdate
})
const clearData = () => {
  if (getCookie(`${PATH[`${path}`].path}-required-two-factor`) === 'true') {
    removeCookie(PATH[`${path}`].header)
    removeCookie(PATH[`${path}`].pathName)
    removeCookie('invited_code')
    // removeCookie('invited_code_employee')
    removeCookie(`${PATH[`${path}`].path}-redirect-path`)
    removeCookie(`${PATH[`${path}`].header}-one-time`)
    removeCookie(`${PATH[`${path}`].path}-required-two-factor`)
    removeCookie(`__Secure-${PATH[`${path}`].path}_unique_user_id`)
    localStorage.removeItem('store')
    store.dispatch(AUTH_STORE.ACTIONS.SET_AUTH_VALUE, false)
    store.dispatch(COMMUNITY_STORE.ACTIONS.LOG_OUT)
  }
}

const onSubmit = async (): Promise<void> => {
  submittingButton.value = true

  try {
    const response = await alumnusServices.updateAlumniProfileApi({
      ...data.value,
      enrollment_start_period: dayjs(data.value?.enrollment_start_period).format('YYYY/MM/DD'),
      authentication_method: data.value.authentication_method === AuthenMethodTypes.EMAIL ? 2 : 1,
    })

    if (response.status === 200) {
      localStorage.removeItem('checkConfirm')
      props.handleError(false)
      //// 2022/09/12 TienNV Fix double click button confirm edit
      modalConfirm.value?.hide()
      modalCompleted?.value?.show()

      setTimeout(() => {
        submittingButton.value = false
      }, 2000)
      clearData()
      return
    } else {
      // localStorage.setItem('serverError', true)
      props.handleError(true)
      window.scrollTo(0, 0)
      //// 2022/09/12 TienNV Fix double click button confirm edit
      modalConfirm.value?.hide()
      modalCompleted?.value?.show()
      submittingButton.value = false
    }
  } catch (error: any) {
    console.log('err', error.response)
    // localStorage.setItem('serverError', true)
    modalConfirm.value?.hide()
    modalCompleted?.value?.show()
    submittingButton.value = false
    window.scrollTo(0, 0)
    props.handleError(true)
  }
}
// 2022/09/12 TienNV Fix double click button confirm edit
onMounted(() => {
  modalConfirm.value = new Modal(document.getElementById('confirmUpdateModal'))
  modalCompleted.value = new Modal(document.getElementById('updateAlumniComplete'))
})
expose({
  showUpdateModal: (): void => modalConfirm.value.show(),
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('account')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.removeValid && _ctx.removeValid(...args)))
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("form", {
              class: "container pt-3 pt-lg-4 pb-3 pb-lg-5 text-break",
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h3", _hoisted_8, _toDisplayString(_unref(translate)('SE40confirmInformation')), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("label", _hoisted_10, _toDisplayString(_unref(translate)('nameKanji')), 1),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(data).family_name), 1),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(data).given_name), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("label", _hoisted_14, _toDisplayString(_unref(translate)('nameKatakana')), 1),
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(data).family_name_kana), 1),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(data).given_name_kana), 1)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_unref(translate)('dateOfBirth')), 1),
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(data).birthday), 1)
                ]),
                (_unref(data).zipcode_judgment)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("label", _hoisted_21, _toDisplayString(_unref(translate)('zipcode')), 1),
                      _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(data).zipcode_foreign), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createElementVNode("label", _hoisted_24, _toDisplayString(_unref(translate)('zipcode')), 1),
                      _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(data).zipcode_1) + "-" + _toDisplayString(_unref(data).zipcode_2), 1)
                    ])),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("label", _hoisted_27, _toDisplayString(_unref(translate)('address1')), 1),
                  _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(PREFECTURES).find((item) => item.id == _unref(data).address_1)?.name), 1)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("label", _hoisted_30, _toDisplayString(_unref(translate)('address2')), 1),
                  _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(data).address_2), 1)
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("label", _hoisted_33, _toDisplayString(_unref(translate)('PhoneNumber')), 1),
                  (_unref(data)?.phone_number_1 && _unref(data)?.phone_number_2 && _unref(data)?.phone_number_3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_unref(data).phone_number_1) + "-" + _toDisplayString(_unref(data).phone_number_2) + "-" + _toDisplayString(_unref(data).phone_number_3), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("h3", _hoisted_35, _toDisplayString(_unref(translate)('SD40currentJob2')), 1),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("label", _hoisted_37, _toDisplayString(_unref(translate)('affiliation')), 1),
                  _createElementVNode("div", _hoisted_38, _toDisplayString(_unref(data).institution), 1)
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("label", _hoisted_40, _toDisplayString(_unref(translate)('SD40Current')), 1),
                  _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(jobName).parent), 1),
                  _createElementVNode("div", _hoisted_42, _toDisplayString(_unref(jobName).child), 1)
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("label", _hoisted_44, _toDisplayString(_unref(translate)('affiliationPeriod')), 1),
                  _createElementVNode("div", _hoisted_45, _toDisplayString(_unref(data).enrollment_start_period) + " " + _toDisplayString(_unref(translate)('SA20from')) + " 現在 ", 1)
                ]),
                _createElementVNode("h3", _hoisted_46, _toDisplayString(_unref(translate)('twoFA')), 1),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("label", _hoisted_48, _toDisplayString(_unref(translate)('method')), 1),
                  _createElementVNode("div", _hoisted_49, _toDisplayString(_unref(data).authentication_method !== _unref(AuthenMethodTypes).EMAIL ? _unref(translate)('useSMS') : _unref(translate)('useEmail')), 1)
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("label", _hoisted_51, _toDisplayString(_unref(data).authentication_method !== _unref(AuthenMethodTypes).EMAIL ? _unref(translate)('phone') : _unref(translate)('email')), 1),
                  (_unref(data).authentication_method !== _unref(AuthenMethodTypes).EMAIL)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(_unref(data).phone_number_1) + "-" + _toDisplayString(_unref(data).phone_number_2) + "-" + _toDisplayString(_unref(data).phone_number_3), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(_unref(data).email), 1))
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _createVNode(Button, {
                      title: _unref(translate)('SE40back'),
                      type: 'secondary',
                      "data-bs-dismiss": "modal"
                    }, null, 8, ["title"])
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createVNode(Button, {
                      class: "button-submit",
                      title: _unref(translate)('update'),
                      type: 'secondary',
                      onClick: onSubmit,
                      disabled: submittingButton.value,
                      loading: submittingButton.value
                    }, null, 8, ["title", "disabled", "loading"])
                  ])
                ])
              ])
            ], 32)
          ])
        ])
      ])
    ]),
    _createVNode(UpdateAlumniComplete)
  ], 64))
}
}

})